var map = {
	"./cam-context-switcher-card-list.ejs": 274,
	"./cam-context-switcher-card.ejs": 275,
	"./cam-context-switcher-favorite.ejs": 276,
	"./cam-context-switcher-menu-item.ejs": 277,
	"./cam-context-switcher-menu-list.ejs": 278,
	"./cam-context-switcher-panel.ejs": 279,
	"./cam-context-switcher-tab-costcenters.ejs": 131,
	"./cam-context-switcher-tab-favorites.ejs": 132,
	"./cam-context-switcher-tab-organizations.ejs": 133,
	"./cam-context-switcher-tab-workspaces.ejs": 134,
	"./cam-context-switcher.ejs": 135
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates ^\.\/.*\.ejs$
// module id = 33
// module chunks = 0 1